// /////////////////////////////////////////////////////////////
// [ファイル] statusVisuals.ts
// [概要] ソース品質管理 UI のステータス・重要度の配色を一元管理する。
//        ツリーのバッジ / メタパネルの表示で共通利用する。
// /////////////////////////////////////////////////////////////
import { ReviewStatus, IssueSeverity, SourceProject } from '../../types/sourceQuality';

/** レビュー状態の表示色 (ツリーのドット・状態セレクト)。 */
export const REVIEW_STATUS_COLOR: Record<ReviewStatus, string> = {
  unreviewed: '#bdbdbd',
  in_review: '#f9a825',
  reviewed: '#43a047',
  needs_fix: '#e53935',
};

/** 課題重要度の表示色。 */
export const ISSUE_SEVERITY_COLOR: Record<IssueSeverity, string> = {
  high: '#e53935',
  medium: '#fb8c00',
  low: '#9e9e9e',
};

/** プロジェクト見出しの表示ラベル。 */
export const PROJECT_LABEL: Record<SourceProject, string> = {
  frontend: 'フロントエンド',
  'functions-node': 'バックエンド (Node)',
  'functions-python': 'バックエンド (Python)',
};

/** ツリーで使うプロジェクトの表示順。 */
export const PROJECT_ORDER: SourceProject[] = [
  'frontend',
  'functions-node',
  'functions-python',
];
